var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgMainmenu4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7164 60.5171C58.7828 68.757 59.8491 73.2203 61.9817 76.482C58.2496 81.6319 49.8258 83.1772 43.8545 81.1172C37.8831 79.0572 27.5045 75.7956 23.0616 74.4223C17.5168 63.7104 20.7512 49.0159 23.0616 43.0076C25.7273 33.2227 34.7908 27.5575 42.7882 25.4976C52.118 23.0946 57.1833 23.9526 65.7138 25.4977C76.9649 27.5355 82.2415 38.8873 76.91 39.4023C74.0962 39.6741 72.4425 38.4295 72.4084 37.4277C71.6574 38.4232 70.7514 39.9494 69.4458 41.4627C67.3132 43.9347 61.2709 42.4927 59.8491 41.4627C58.7828 42.4926 56.6501 52.2772 57.7164 60.5171Z",
    fill: "#95C9F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 82.0712C14.02 82.0712 22.3719 70.8594 37.1806 78.8954C51.9894 86.9314 59.4289 81.6325 63.2363 79.0358C68.2194 75.6143 75.3606 71.7718 85.467 78.7726C92.6784 83.7907 99.0651 83.5275 103.013 78.5269",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9865 76.1589C24.9865 76.1589 19.0736 67.2631 21.6353 50.4542C24.197 33.6452 38.4442 18.0995 61.6575 18.0995C86.2218 18.0995 89.0818 35.2769 82.5021 38.3826C75.9223 41.4882 71.9745 34.8734 71.9745 34.8734C71.9745 34.8734 70.448 46.3484 59.4643 38.8563C59.4643 38.8563 56.6218 50.963 46.4978 41.1022C46.4978 41.1022 46.6733 57.1567 34.4789 45.4711C34.4789 45.4711 33.2857 57.7533 21.7932 49.8751",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6229 39.8564C69.6229 39.8564 59.2182 55.9987 72.2197 74.9483",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 92.3707C14.02 92.3707 22.3719 81.1588 37.1806 89.1949C51.9894 97.2309 59.4289 91.932 63.2363 89.3352C68.2194 85.9313 75.3606 82.0712 85.467 89.072C92.6784 94.0902 99.0651 93.827 103.013 88.8264",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 92.3707C14.02 92.3707 22.3719 81.1588 37.1806 89.1949C51.9894 97.2309 59.4289 91.932 63.2363 89.3352C68.2194 85.9313 75.3606 82.0712 85.467 89.072C92.6784 94.0902 99.0651 93.827 103.013 88.8264",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5864 18.6586C15.5864 17.8253 15.8335 17.0107 16.2965 16.3178C16.7595 15.625 17.4175 15.0849 18.1874 14.766C18.9573 14.4471 19.8044 14.3637 20.6217 14.5263C21.439 14.6888 22.1898 15.0901 22.779 15.6794C23.3682 16.2686 23.7695 17.0193 23.9321 17.8366C24.0947 18.6539 24.0112 19.5011 23.6923 20.271C23.3734 21.0409 22.8334 21.6989 22.1405 22.1619C21.4477 22.6248 20.6331 22.8719 19.7997 22.8719C18.6823 22.8719 17.6106 22.428 16.8205 21.6379C16.0303 20.8477 15.5864 19.7761 15.5864 18.6586Z",
    fill: "#FFCE26",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4429 55.5446C77.0016 55.1024 76.7012 54.5394 76.5798 53.9266C76.4584 53.3137 76.5213 52.6787 76.7607 52.1016C77 51.5246 77.405 51.0314 77.9245 50.6845C78.4441 50.3375 79.0548 50.1523 79.6795 50.1523C80.3042 50.1523 80.9149 50.3375 81.4345 50.6845C81.954 51.0314 82.359 51.5246 82.5984 52.1016C82.8377 52.6787 82.9007 53.3137 82.7792 53.9266C82.6578 54.5394 82.3574 55.1024 81.9161 55.5446C81.3207 56.1335 80.517 56.4639 79.6795 56.4639C78.842 56.4639 78.0383 56.1335 77.4429 55.5446Z",
    fill: "#FFCE26",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3906 47.9971C37.3906 47.9971 31.0565 64.4551 40.3383 80.457",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.111 43.3655C46.7976 49.8919 46.0122 56.8621 46.8152 63.7396C47.6183 70.6172 49.9884 77.2189 53.7431 83.0368",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9378 39.8564C60.9378 39.8564 50.1997 56.4198 63.2363 79.0365",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.02 103.302C14.02 103.302 22.3719 92.0898 37.1806 100.126C51.9894 108.162 59.4289 102.863 63.2363 100.266C68.2194 96.8623 75.3606 93.0022 85.467 100.021C92.6784 105.021 99.0651 104.758 103.013 99.7749",
    stroke: "#18193F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 45H14",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9H80",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94 32H100",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40L9 50",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77 6L77 12",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97 29L97 35",
    stroke: "#18193F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMainmenu4);
export default __webpack_public_path__ + "static/media/img-mainmenu-4.060ff0d0864b9f901749d4152f02c6d4.svg";
export { ForwardRef as ReactComponent };